import { render, staticRenderFns } from "./inventory-product-filter.vue?vue&type=template&id=a860e2ee&scoped=true&"
import script from "./inventory-product-filter.vue?vue&type=script&lang=js&"
export * from "./inventory-product-filter.vue?vue&type=script&lang=js&"
import style0 from "./inventory-product-filter.vue?vue&type=style&index=0&id=a860e2ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a860e2ee",
  null
  
)

export default component.exports